import React, { useEffect } from 'react'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import routes from './routes'
import 'dayjs/locale/en-gb'
import '@/locales'
import { useTranslation } from 'react-i18next'
import usePersistDataStore from './stores/persistData'
import useGlobalConfigStore from './stores/globalConfig'
import appConfig from '@/config'
import { useJsApiLoader } from '@react-google-maps/api'
import { RouteMeta, Routes } from './type/publicPropsType'

// const RouteTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const location = useLocation()
//   let webAppDom: any = document.getElementById("WebApp")
//   if (webAppDom) {
//     webAppDom.classList.remove("app-loaded")

//     setTimeout(() => {
//       webAppDom.classList.add("app-loaded")
//     }, 1500)
//   }
//   return <div> {children}</div>
//   return (
//     <TransitionGroup>
//       <CSSTransition key={location.key} timeout={300} classNames="errr fade">
//         {children}
//       </CSSTransition>
//     </TransitionGroup>
//   )
// }

const App: React.FC = () => {
  const element = useRoutes(routes)
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const isLogin = usePersistDataStore(state => state.isLogin)
  const lang = usePersistDataStore(state => state.lang)
  const setMapOk = useGlobalConfigStore(state => state.setMapOk)
  const location = useLocation()
  const { t } = useTranslation()

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: appConfig.googleApiKey,
    language: 'en',
    region: 'US',
  })

  const findPathMeta: (path: string, routes: Routes[]) => undefined | RouteMeta = (path, routes) => {
    for (let route of routes) {
      if (route.children) {
        let meta = findPathMeta(path, route.children)
        if (meta) {
          return meta
        }
      } else {
        if (route.path === '/' || route.path === '' || route.path === '*') {
          continue
        } else if (path.includes(route.path)) {
          return route.meta
        }
      }
    }
    return undefined
  }

  useEffect(() => {
    if (isLoaded) {
      setMapOk()
    }
  }, [isLoaded])

  useEffect(() => {
    i18n.changeLanguage(lang)
  }, [lang])
  useEffect(() => {
    if (!isLogin) {
      navigate('/login')
    }
  }, [isLogin])
  useEffect(() => {
    const { pathname } = location
    const meta = findPathMeta(pathname, routes)
    if (meta) {
      document.title = t(meta.title)
    } else {
      document.title = t('menu.loading')
    }
  }, [location, t])

  return <div id='WebApp'>{element}</div>
}

export default App
